import Navbar from "components/navbar";
import Card from "components/card";
import Loader from "components/loader/loader";
import CardAppConfig from "components/card/CardAppConfig";
import { Formik } from "formik";
import { t } from "i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import * as Yup from "yup";
import { getAppConfig, updateAppConfig } from "services/customAPI";
import { errorToast, successToast } from "utils/commons";

type FormValues = {
  name: string;
  value: string;
  placeHolder: string;
  active: boolean;
};

export default function EditConfig() {
  const { configName } = useParams<{ configName: string }>();
  const navigate = useNavigate();
  const [initialValues, setInitialValues] = useState<FormValues | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const appSchema = Yup.object().shape({
    name: Yup.string().required().defined(),
    value: Yup.string().required(),
    placeHolder: Yup.string().required(),
    active: Yup.boolean(),
  });


  useEffect(() => {
    if (!configName) return;
    (async () => {
      try {

        const resp = await getAppConfig(configName);
        if (resp?.data) {
          setInitialValues(resp.data);
        } else {
          navigate("/admin/settings/general");
        }
      } catch (err) {
        console.error("Erro ao carregar config", err);
        navigate("/admin/settings/general");
      } finally {
        setIsLoading(false);
      }
    })();
  }, [configName, navigate]);

  const handleSubmit = async (values: FormValues) => {
    try {
      const response = await updateAppConfig(configName!, values);
      setIsLoading(true);
      if (response) {
        navigate("/admin/settings/general");
        successToast(t("salveConfigs"));
        setIsLoading(false);
      }

    } catch (error: any) {
      errorToast(t("alredyExists"));
      console.error("Erro ao salvar config", error.message);
      setIsLoading(false);
    }
  };

  if (isLoading || !initialValues) {
    return (
      <>
        <Navbar flag={false} brandText={t("Settings")} />
        <Loader />
      </>
    );
  }

  return (
    <>
      <Navbar flag={false} brandText={t("Settings")} />
      <Card className="w-50 mt-4 pb-10 h-full">
        <header className="relative flex items-center justify-between p-10">
          <h2 className="text-xl font-bold text-navy-700 dark:text-white">
            {t("Edit")}
          </h2>
        </header>

        <div className="px-20 pb-5">
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={appSchema}
            onSubmit={handleSubmit}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
            }) => (
              <form onSubmit={handleSubmit}>
                <div className="grid grid-cols-3 gap-8 w-full">
                  <CardAppConfig
                    handleChange={handleChange}
                    values={values}
                    errors={errors}
                    touched={touched}
                  />
                </div>
              </form>
            )}
          </Formik>
        </div>
      </Card>
    </>
  );
}
